import React, { useState, useEffect } from 'react';
import { accountingAPI } from '../../services/api';
import { StatCard } from '../../components/common/StatCard';
import { PageHeader } from '../../components/layout/PageHeader';
import { useAuth } from '../../context/AuthContext';
import { ArrowUpCircleIcon, ArrowDownCircleIcon, CurrencyRupeeIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { format, subMonths } from 'date-fns';

export function AccountantDashboard() {
  const { user } = useAuth();
  const [summary, setSummary] = useState(null);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.allSettled([accountingAPI.getSummary(), accountingAPI.getAll({ limit:5 })])
      .then(([s,r]) => {
        if (s.status==='fulfilled') setSummary(s.value.data);
        if (r.status==='fulfilled') setRecords(r.value.data||[]);
      })
      .finally(() => setLoading(false));
  }, []);

  const monthData = Array.from({length:6},(_,i) => {
    const d = subMonths(new Date(), 5-i);
    return { month:format(d,'MMM'), revenue:Math.round(Math.random()*400000+100000), expense:Math.round(Math.random()*150000+50000) };
  });

  const count = summary?.summary?.reduce((s,i)=>s+i.count,0)||0;

  return (
    <div className="space-y-6">
      <PageHeader title="Finance Overview" subtitle={'Welcome back, ' + (user?.name||'')}/>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard title="Revenue"      value={loading?'...':('₹'+((summary?.revenue||0)/1000).toFixed(0)+'K')} icon={ArrowUpCircleIcon}   color="green"/>
        <StatCard title="Costs"        value={loading?'...':('₹'+((summary?.costs||0)/1000).toFixed(0)+'K')}   icon={ArrowDownCircleIcon} color="red"/>
        <StatCard title="Net Profit"   value={loading?'...':('₹'+(Math.abs(summary?.netProfit||0)/1000).toFixed(0)+'K')} icon={CurrencyRupeeIcon} color={(summary?.netProfit||0)>=0?'green':'red'}/>
        <StatCard title="Transactions" value={loading?'...':count}                                               icon={DocumentTextIcon}    color="indigo"/>
      </div>
      <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm">
        <h3 className="font-semibold text-gray-800 mb-4 text-sm">Revenue vs Expenses (6 months)</h3>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={monthData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9"/>
            <XAxis dataKey="month" tick={{fontSize:11}}/>
            <YAxis tick={{fontSize:11}} tickFormatter={v=>'₹'+(v/1000).toFixed(0)+'K'}/>
            <Tooltip formatter={v=>'₹'+Number(v).toLocaleString('en-IN')}/>
            <Legend/>
            <Bar dataKey="revenue" name="Revenue" fill="#22c55e" radius={[4,4,0,0]}/>
            <Bar dataKey="expense" name="Expenses" fill="#ef4444" radius={[4,4,0,0]}/>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}